<template>
  <div id="deviceInfo">
    <div v-if="!loading && !device.state" class="ma-2">
      <v-row align="center" style="min-height: 200px;">
        <v-col cols="2" class="text-center"><v-icon size="72" color="red">warning</v-icon></v-col>
        <v-col cols="9">
          <h2 class="my-5">This device has no state</h2>
          <p>
            The device has not published state correctly, you may experience inconsistent behavior.
          </p>
        </v-col>
      </v-row>
    </div>
    <div v-else-if="!loading && !device.hasCompleteState()" class="ma-2">
      <v-row align="center" style="min-height: 200px;">
        <v-col cols="2" class="text-center"><v-icon size="72" color="red">warning</v-icon></v-col>
        <v-col cols="9">
          <h2 class="my-5">This device has incomplete state</h2>
          <p>
            The device has not published state correctly, you may experience inconsistent behavior.
          </p>
        </v-col>
      </v-row>
    </div>
    
    <v-progress-linear
      color="primary"
      indeterminate
      buffer-value="0"
      v-if="loading"
    ></v-progress-linear>
    
    <encoder-info v-if="device.device_type == 'encoder'" :device_guid="device_guid" :device="device" />
    <decoder-info v-else-if="device.device_type == 'decoder'" :device_guid="device_guid" :device="device" />
    <pre v-else-if="device.isReady()">{{ device.state }}</pre>
    
    <device-events class="mt-5" v-if="!loading && (device.hasFeature('services.cloud.device_events.enabled') || isDeviceAdmin)" heading="Device Events" targetObject="devices" :targetGUID="device_guid" />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  
  import DeviceEvents from '../components/DeviceEvents.vue'
  
  import EncoderInfo from '../components/info/EncoderInfo.vue'
  import DecoderInfo from '../components/info/DecoderInfo.vue'
  
  export default {
    name: 'DeviceInfo',
    components: {
      DeviceEvents,
      EncoderInfo,
      DecoderInfo
    },
    
    props: ['device_guid', 'device'],
    
    data() {
      return {
        debug: false,
        inputPreviewSupportedVersion: this.$helpers.parseVersion('cloud', 'v1.3.0'),
      }
    },
    
    mounted() {
      setTimeout(() => {
        this.device.fetchMetrics()
      }, 500)
      
    },
    
    computed: {
      ...mapGetters('user', ['user', 'guid', 'isAdmin', 'isDeviceAdmin', 'organization']),
      
      loading() {
        if (this.device && !this.device.ready) {
          return true
        }
        return false
      },
      online() {
        return this.device.isOnline()
      },
      icon() {
        if (this.device) {
          return this.device.icon()
        }
        return ''
      },
      
      deviceName() {
        if (this.device) {
          return this.device.deviceName()
        }
        
        return this.device_guid
      },
      
      productName() {
        if (this.device) {
          return this.device.product_name
        }
        
        return 'edgecaster'
      },
      
      externalIP() {
        if (this.device && this.device.external_ip) {
          return this.device.external_ip
        }
        return 'Unknown'
      },
      
      uptime() {
        if (!this.device.isOnline()) {
          return 'Offline'
        } else if (this.device && this.device.state) {
          if (this.device.state.last_boot && this.device.last_api_request_id) {
            return moment(this.device.state.last_boot).fromNow(true)
          }
        }
        return 'Unknown'
      },
      
      inputsState() {
        return this.device.inputsState()
      },
      
      outputsState() {
        return this.device.outputsState()
      },
    },
    methods: {
      inputName(shadowDocument) {
        if (shadowDocument.config.name) {
          return this.$helpers.htmlDecode(shadowDocument.config.name)
        }
        
        return 'Input #' + shadowDocument.id
      },
      outputName(shadowDocument) {
        if (shadowDocument.config.name) {
          return this.$helpers.htmlDecode(shadowDocument.config.name)
        }
        
        var outputName = 'Output #' + shadowDocument.id
        if (shadowDocument.type) {
          outputName += ' (' + this.$helpers.getLabel(shadowDocument.type) + ')'
        }
        return outputName
      },
      isPreviewSupported(index = 0) {
        if (this.device.thumbnailEnabled(index) && this.$helpers.versionCheck(this.inputPreviewSupportedVersion, this.device.cloud_version)) {
          return true
        }
        return false
      }
    }
  }
</script>